import SectionMessage from '@atlaskit/section-message';
import FadeInProps from "!!extract-react-types-loader!../../../../../../packages/design-system/motion/src/entering/fade-in";
import SlideInProps from "!!extract-react-types-loader!../../../../../../packages/design-system/motion/src/entering/slide-in";
import ZoomInProps from "!!extract-react-types-loader!../../../../../../packages/design-system/motion/src/entering/zoom-in";
import ShrinkOutProps from "!!extract-react-types-loader!../../../../../../packages/design-system/motion/src/entering/shrink-out";
import StaggeredEntranceProps from "!!extract-react-types-loader!../../../../../../packages/design-system/motion/src/entering/staggered-entrance";
import ExitingPersistenceProps from "!!extract-react-types-loader!../../../../../../packages/design-system/motion/src/entering/exiting-persistence";
import * as React from 'react';
export default {
  SectionMessage,
  FadeInProps,
  SlideInProps,
  ZoomInProps,
  ShrinkOutProps,
  StaggeredEntranceProps,
  ExitingPersistenceProps,
  React
};